const makeYearsOptions = ({
  endYear = new Date().getFullYear(),
  numberOfYears = 100,
}) => {
  const startYear = endYear - numberOfYears;
  const years = [];
  for (let i = startYear; i <= endYear; i += 1) {
    years.push(i);
  }
  years.reverse();
  return years.map((year) => ({
    value: year,
    label: year.toString(),
  }));
};

export default makeYearsOptions;
